// Simple reducer to replace state in original FieldContainer class component

type State = {
  required: boolean;
  text: string;
  title: string;
  description: string;
  unit: string;
  fileUpload: boolean;
  enumValue: string[];
  url?: string;
  width?: number;
};

export const INIT_FIELD_STATE: State = {
  title: '',
  description: '',
  required: false,
  text: '',
  unit: '',
  enumValue: [],
  fileUpload: false,
};

export const fieldContainerStateReducer = (state: State, action) => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return { ...state, ...action.data };
    default: {
      return state;
    }
  }
};
